import { AppConfig } from "../config";
import { mainColor } from "./getMainColor";
import { identity } from "./getIdentity";

const colorsObj = {
  BTC: {
    color: '#EEA922',
    bgColor: '#FBF7F3',
  },
  ETH: {
    color: '#CD081E',
    bgColor: '#EBF6FF',
  },
  USDT: {
    color: '#08CD1F',
    bgColor: 'rgba(113, 251, 135, 0.22)',
  },
  BNB: {
    color: '#EEA922',
    bgColor: '#FBF7F3',
  },
  BUSD: {
    color: '#EEA922',
    bgColor: '#FBF7F3',
  },
  TRX: {
    color: '#FC0D24',
    bgColor: 'rgba(252, 13, 36, 0.07)',
  },
  LOTT: {
    color: '#390C7F',
    bgColor: 'rgba(57, 12, 127, 0.1)',
  },
  default: {
    color: identity === 'inex' ? '#ac98ed' : identity === 'coinera' ? '#ee2c03' : '#230f63',
    bgColor: identity === 'inex' ? '#eeebfa' : '#EBF6FF',
  },
};

export const tokenColors = currency => {
  return colorsObj[currency] || colorsObj.default;
};
